import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SearchService } from '../search.service';

@Component({
  selector: 'app-search-result-dialog',
  standalone: true,
  imports: [],
  templateUrl: './search-result-dialog.component.html',
  styleUrl: './search-result-dialog.component.scss'
})
export class SearchResultDialogComponent {

  constructor(
    private router: Router,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private searchService: SearchService
  ) { }


  //FIX ME - When navigating back, fill search form with orginal search data
  onClose(): void {
    this.searchService.closeDialog();
    localStorage.removeItem('searchResponse');
    this.router.navigate(['search'], { queryParams: { form: this.config.data.form } });
  }

}
